import { useState } from "react";
import { motion } from "framer-motion";
import { GALLERY } from "@/lib/data";
import { useContent } from "@/context/ContentContext";

const CATEGORIES = ["Semua", "Pelaminan", "Aisle & Arch", "Meja VVIP", "Photo Booth"];

export const Gallery = () => {
  const [active, setActive] = useState("Semua");
  const { gallery } = useContent();
  const all = gallery && gallery.length ? gallery : GALLERY;
  const items = active === "Semua" ? all : all.filter((g) => g.category === active);

  return (
    <section id="galeri" className="py-24 bg-[#1C1917]" data-testid="gallery-section">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="max-w-2xl mb-12">
          <p className="font-mono text-xs tracking-[0.3em] uppercase text-[#C5A059] mb-3">
            Galeri
          </p>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-medium text-white tracking-tight">
            Galeri Karya Ascarya
          </h2>
          <p className="mt-4 text-white/60">
            Koleksi momen manis yang telah kami rangkai dengan hati.
          </p>
        </div>

        <div className="flex flex-wrap gap-3 mb-10">
          {CATEGORIES.map((c) => (
            <button
              key={c}
              onClick={() => setActive(c)}
              data-testid={`gallery-filter-${c.replace(/[^a-zA-Z]/g, "").toLowerCase()}`}
              className={`px-5 py-2 rounded-full text-[11px] font-semibold tracking-widest uppercase transition-all border ${
                active === c
                  ? "bg-[#C5A059] text-white border-[#C5A059]"
                  : "bg-transparent text-white/70 border-white/20 hover:border-[#C5A059] hover:text-white"
              }`}
            >
              {c}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {items.map((item, i) => (
            <motion.div
              key={item.id}
              layout
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.06 }}
              className="group relative rounded-2xl overflow-hidden aspect-[3/4]"
              data-testid={`gallery-item-${item.id}`}
            >
              <img
                src={item.image}
                alt={item.title}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1C1917]/90 via-transparent to-transparent opacity-80" />
              <div className="absolute bottom-0 inset-x-0 p-5">
                <div className="font-mono text-[9px] tracking-widest uppercase text-[#E8D9BD]">
                  {item.category}
                </div>
                <div className="font-serif text-lg text-white mt-1 leading-tight">
                  {item.title}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
